import React from 'react';
import { Card, CardContent, CardHeader, Divider, Grid } from '@material-ui/core';
// import { useStore } from '@tanstack/react-form'; // KALDIRILDI
import { FieldLabel, FieldText } from '../../components/Field';
import moment from 'moment';

function useFormValues(form, selector) {
    const [selected, setSelected] = React.useState(() => selector(form.values));
    React.useEffect(() => {
        const unsub = form.subscribe(() => setSelected(selector(form.values)));
        return unsub;
    }, [form, selector]);
    return selected;
}

export function Details({ form }) {
    const {
        IssueReason,
        WorkOrderComments,
        StatusNote,
        OpenDate,
        AppointmentDate,
        Brand
    } = useFormValues(form, v => ({
        IssueReason: v.IssueReason,
        WorkOrderComments: v.WorkOrderComments || [],
        StatusNote: v.StatusNote,
        OpenDate: v.OpenDate,
        AppointmentDate: v.AppointmentDate,
        Brand: v.Brand
    }));

    return (
        <Card>
            <CardHeader title="Work Order Detail" />
            <Divider />
            <CardContent>
                <Grid container>
                    <Grid item xs={12} sm={6} lg={6}>
                        <FieldLabel>Application Type</FieldLabel>
                        <FieldText>{IssueReason}</FieldText>
                        <FieldLabel>Application Note</FieldLabel>
                        {WorkOrderComments.length > 0 ? (
                            WorkOrderComments.map((comment, index) => <FieldText key={index}>{comment.Dsc}</FieldText>)
                        ) : (
                            <FieldText>No additional comments available</FieldText>
                        )}
                        <FieldLabel>Last Note</FieldLabel>
                        <FieldText>{StatusNote}</FieldText>
                        <FieldLabel>Call Date</FieldLabel>
                        <FieldText>
                            {OpenDate ? moment(OpenDate).format('DD/MM/YYYY HH:mm') : 'Not specified'}
                        </FieldText>
                        <FieldLabel>Appointment</FieldLabel>
                        <FieldText>
                            {AppointmentDate ? moment(AppointmentDate).format('DD/MM/YYYY HH:mm') : 'Not specified'}
                        </FieldText>
                        <FieldLabel>CC Brand</FieldLabel>
                        <FieldText>{Brand || 'Not specified'}</FieldText>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}
